import React from "react";
import { MDBContainer, MDBRow, MDBCol, MDBIcon } from "mdb-react-ui-kit";
import Imageabout from "../img/rcm2.gif";
import { BrowserRouter, Link } from "react-router-dom";
import "../css/servicesfont.css";
function App() {
  return (
    <MDBContainer fluid className="p-0">
      <div className="container py-5">
        <div className="row">
          <div className="col-12">
            <div className="section-title mb-4 pb-2">
              {/* <div className="title mb-4 display-heading AcerhealthTextPurple text-center fomtsizetest" style={{fontFamily:'Lora, serif'}}> Revenue Cycle Management </div> */}
              <h1 className="title mb-4 display-heading AcerhealthTextPurple text-center fomtsizetest" style={{ fontFamily: 'Lora, serif' }}> Revenue Cycle Management </h1>
              <p className="para-desc mx-auto mb-0" style={{ fontSize: '20px', fontFamily: 'Alegreya Sans', fontWeight: '500',textAlign:'justify' }}>
               At AcerHealth, we understand that increasing revenue and accelerating reimbursement cycles are key to the financial success of any healthcare practice.
                Our expert<a
                            href="https://acerhealth.com/blog/revenue-cycle-management-in-healthcare"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ color: "#007BFF", textDecoration: "none", margin: "0 5px" }}
                        >
                        revenue cycle management (RCM)
                        </a>solutions optimize every stage of your revenue flow, helping you collect payments faster and reduce costly denials. A well-structured 
                        <a
                            href="https://acerhealth.com/blog/medical-billing-process"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ color: "#007BFF", textDecoration: "none", margin: "0 5px" }}
                        >
                       medical billing process
                        </a>serves as the foundation of an efficient revenue cycle and supports faster reimbursements.

              </p>
              <p className="para-desc mx-auto mb-0" style={{ fontSize: '20px', fontFamily: 'Alegreya Sans', fontWeight: '500' ,textAlign:'justify'}}>
              We leverage deep industry knowledge and advanced 
              <a
                            href="https://www.acerhealth.com/services/medical-billing-services"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ color: "#007BFF", textDecoration: "none", margin: "0 5px" }}
                        >
              medical billing services
                        </a>   to streamline claims processing,
               improve operational efficiency, and boost overall profitability. By partnering with us for
                <a
                            href="https://acerhealth.com/services/medical-billing-and-credentialing"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ color: "#007BFF", textDecoration: "none", margin: "0 5px" }}
                        >
              medical billing outsourcing
                        </a>    
                and
                 <a
                            href="https://acerhealth.com/services/denial-management-services"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ color: "#007BFF", textDecoration: "none", margin: "0 5px" }}
                        >
             healthcare denial management,
                        </a>   you gain a trusted ally committed to enhancing your practice’s 
               financial health and freeing you to focus on delivering exceptional patient care.

              </p>
            </div>
          </div>
        </div>
      </div>
    </MDBContainer>
  );
}

export default App;
